async function getOptions(prompt) {

    const parameters = {
        method: "POST",
        body: JSON.stringify({message: "List 3 subcategories within the category of " + prompt + ". Each subcategory should have distinct learnable skillsets related to them, but do not include these in the response. Respond with JSON: {options: [Subcategory, Subcategory, Subcategory]}"}),
        headers: {"Content-Type": "application/json"}
    }

    try {
        const response = await fetch(`/api/completions`, parameters)
        if (!response.ok) return null
        const data = await response.json()
        const options = JSON.parse(data.candidates[0].content.parts[0].text)
        if (!Array.isArray(options.options)) return null
        return options.options
    } catch (error) {
        console.error(error)
        return null
    }
}

export default getOptions
